import React from "react";
import PropTypes from "prop-types";
import Switch from "@mui/material/Switch";
import getStyled from "../../hooks/getStyled";
import SFTypography from "../typography";
import { SFStack } from "../grid";

const { styled } = getStyled();

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 36,
  height: 17,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(19px)",
      color: `${theme.palette.white.main}`,
      "& + .MuiSwitch-track": {
        opacity: 1,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 12,
      height: 12,
      borderRadius: 6,
      border: `1px solid ${theme.palette.grey350.main}`,
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 8,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? `${theme.palette.grey450.main}`
        : `${theme.palette.grey250.main}`,
    boxSizing: "border-box",
    border: `1px solid ${theme.palette.white.main}`,
  },
  "& .MuiSwitch-switchBase.Mui-disabled": {
    "& .MuiSwitch-thumb": {
      backgroundColor: theme.palette.grey250.main,
    },
    "& .MuiSwitch-track": {
      backgroundColor: theme.palette.grey450.main,
    },
  },
}));

const SFSwitch = ({
  disabled,
  checked,
  onChange,
  leftLabel,
  rightLabel,
  className,
}) => {
  return (
    <SFStack direction="row" spacing={1} alignItems="center">
      {leftLabel && (
        <SFTypography variant="formElementLabel">{leftLabel}</SFTypography>
      )}
      <StyledSwitch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={className}
      />
      {rightLabel && (
        <SFTypography variant="formElementLabel">{rightLabel}</SFTypography>
      )}
    </SFStack>
  );
};

SFSwitch.defaultProps = {
  color: "default",
  disabled: false,
  checked: false,
  leftLabel: null,
  rightLabel: null,
};

SFSwitch.propTypes = {
  /* The color of the component. It supports both default and custom theme colors,
   which can be added as shown in the palette customization guide.
 */
  color: PropTypes.oneOf(["default"]),
  /* If true, the component is disabled. */
  disabled: PropTypes.bool,
  /* The label to be shown left of the switch. */
  leftLabel: PropTypes.string,
  /* The label to be shown left of the switch. */
  rightLabel: PropTypes.string,
  /* Callback fired when the state is changed.*/
  onChange: PropTypes.func,
  /* Whether the switch is in it's on or off position. */
  checked: PropTypes.bool,
};

export default SFSwitch;
